"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionHeaderRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var DashboardLayoutItemRenderer_1 = require("./DashboardLayoutItemRenderer");
var DashboardLayoutSectionHeader_1 = require("./DashboardLayoutSectionHeader");
var emptyItemFacadeWithFullSize = {
    index: function () { return 0; },
    raw: function () { return null; },
    widget: function () { return null; },
    section: function () { return undefined; },
    size: function () { return ({ xl: { gridWidth: 12 } }); },
    sizeForScreen: function () { return ({ gridWidth: 12 }); },
    isLast: function () { return true; },
    widgetEquals: function () { return false; },
    widgetIs: function () { return false; },
    hasSizeForScreen: function () { return false; },
    indexIs: function () { return false; },
    isFirst: function () { return true; },
    test: function () { return false; },
    testRaw: function () { return false; },
    isCustomItem: function () { return false; },
    isInsightWidgetItem: function () { return false; },
    isInsightWidgetDefinitionItem: function () { return false; },
    isKpiWidgetItem: function () { return false; },
    isKpiWidgetDefinitionItem: function () { return false; },
    isLayoutItem: function () { return false; },
    isWidgetItem: function () { return false; },
    isWidgetDefinitionItem: function () { return false; },
    isWidgetItemWithInsightRef: function () { return false; },
    isWidgetItemWithKpiRef: function () { return false; },
    isWidgetItemWithRef: function () { return false; },
    isEmpty: function () { return false; },
};
function DashboardLayoutSectionHeaderRenderer(props) {
    var section = props.section, screen = props.screen;
    var sectionHeader = section.header();
    return sectionHeader ? (React.createElement(DashboardLayoutItemRenderer_1.DashboardLayoutItemRenderer, { DefaultItemRenderer: DashboardLayoutItemRenderer_1.DashboardLayoutItemRenderer, item: emptyItemFacadeWithFullSize, screen: screen },
        React.createElement(DashboardLayoutSectionHeader_1.DashboardLayoutSectionHeader, { title: sectionHeader.title, description: sectionHeader.description }))) : null;
}
exports.DashboardLayoutSectionHeaderRenderer = DashboardLayoutSectionHeaderRenderer;
//# sourceMappingURL=DashboardLayoutSectionHeaderRenderer.js.map